export enum DiaryType {
  simple = 'Simple',
  detailed = 'Preschool',
}
